import React from "react";
import "./styles/ButtonFACul.css";

function ButtonFACul() {
  return (
    <div className="buttonfacul">
      <h3>F.A.Cul </h3>
    </div>
  );
}

export default ButtonFACul;
